import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import * as styles from "./stores.styles";
import { getAppById } from "apis";
import { withRedux, isMobileDevice } from "helpers";
import { FlexRow, H1 } from "appStyles";
import { cloneDeep } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StoreItemsTable from "./StoreItemsTable";

function parseQuery(queryString) {
  var query = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

const isMob = isMobileDevice();

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  paper: {
    width: "100%",
    marginTop: theme.spacing(2),
    boxShadow: "none",
  },
  table: {
    maxWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  MuiSvgIcon: {
    fontSize: "1.15rem",
  },
  paginationSpacer: {
    flex: "none",
  },
  paginationToolbar: {
    justifyContent: !isMob ? "center" : "unset",
  },
  MuiTableCell: {
    letterSpacing: 0,
    overflowWrap: "anywhere",
    textAlign: "center",
  },
  icon: {
    backgroundColor: "rgb(83,95,103)",
    borderRadius: "100px",
    padding: "5px",
    color: "white",
    // boxShadow: "3px 3px 13px rgb(120 120 120 / 50%)",
  },
}));

const Stores = (props) => {
  const {
    platformInfo: { status: user },
    actions: {
      getPunchCards,
      removePunchCards,
      setPunchCards,
      updateActiveEditor,
    },
  } = props;

  const [stores, setStores] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  // console.dir(user);
  const classes = useStyles();

  useEffect(() => {
    getStores();
    getDefaultPunchcards();
    updateActiveEditor(null);
  }, []);

  useEffect(() => {}, [selectedStore]);

  const EnhancedTableHead = (props) => {
    return (
      <TableHead>
        <TableRow
          style={{
            textAlign: "left",
            borderBottom: "1pt solid black",
            backgroundColor: "#89d2d3",
            color: "white",
          }}
        >
          {" "}
          <TableCell
            style={{ lineHeight: "0.5em" }}
            className={classes.MuiTableCell}
          >
            <span
              style={{
                padding: "0px 0px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              Store Manager
            </span>
          </TableCell>
        </TableRow>
      </TableHead>
    );
  };

  const getStores = async () => {
    const path = props.history.location.pathname;
    const appId = path.substring(1, path.lastIndexOf("/stores"));

    let accessTokenTemp = null;

    const query = parseQuery(props.history.location.search);
    accessTokenTemp = query.accessCode;
    setAccessToken(accessTokenTemp);

    try {
      const application = await getAppById(appId, accessTokenTemp);
      const cards = await getDefaultPunchcards(appId, accessTokenTemp);
      const view = JSON.parse(
        decodeURI(
          application.publishedView !== null
            ? application.publishedView
            : application.unpublishedView
        )
      );
      const storesArr = [];
      view.templates.forEach((t) => {
        if (t.type === "store") {
          storesArr.push(t);
        }
      });

      const appState = { view, ...application };
      // console.dir(appState);

      props.actions.setApplication(cloneDeep(appState));

      setStores(storesArr);
      // setStores([]);

      return application;
    } catch (e) {
      console.error(e);
    }
  };

  const getDefaultPunchcards = async (appId, accessToken) => {
    // console.log("fetching punchcards with appId: " + appId);
    if (!appId) return null;
    try {
      await getPunchCards(appId, accessToken).then((punchCards) => {
        // console.log("GOT BACK defaultPunchCards FROM API");
        // console.dir(punchCards);
        // setStore(store);
        setPunchCards(punchCards);
        return punchCards;
      });
    } catch (e) {
      console.error(e);
    }
  };
  // console.log("selected store:");
  // console.dir(selectedStore);

  const handleClick = (e, store) => {
    const { activeApp } = props;
    e.preventDefault();
    setSelectedStore(store);
    props.actions.setTemplate(activeApp.id, store.id);
  };

  const RenderStoreRows = () => {
    if (!stores) return null;
    return (
      <TableBody>
        {stores.map((store) => {
          const { id, pageName } = store;
          return (
            <TableRow
              hover
              onClick={(e) => handleClick(e, store)}
              role="checkbox"
              tabIndex={-1}
              key={id}
            >
              <TableCell width="100%" className={classes.MuiTableCell}>
                {pageName}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };
  if (!stores) return null;
  if (stores.length < 1)
    return (
      <div className={styles.textContainer}>
        <Paper className={classes.paper}>
          {" "}
          <styles.P style={{ textAlign: "center" }}>
            You do not have any store pages created.
          </styles.P>
        </Paper>
      </div>
    );
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {selectedStore ? (
          <div>
            {/* <div className={styles.arrowContainer}>
              <FontAwesomeIcon
                className={styles.arrowStyle}
                icon="arrow-left"
              />
            </div> */}

            <FlexRow className={styles.headerContainer}>
              <H1 className={styles.headerText}>{selectedStore.pageName}</H1>
            </FlexRow>
            <StoreItemsTable
              selectedStore={selectedStore}
              accessToken={accessToken}
              setSelectedStore={setSelectedStore}
            />
          </div>
        ) : (
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"medium"}
              aria-label="enhanced table"
              style={{
                borderCollapse: "collapse",
                margin: "auto",
                tableLayout: "fixed",
              }}
            >
              <EnhancedTableHead classes={classes} />
              {RenderStoreRows()}
            </Table>
          </TableContainer>
        )}
      </Paper>
    </div>
  );
};

export default withRedux(Stores);
